import { z } from 'zod';

export const PermitsExtensionDefinitionsScalarFieldEnumSchema = z.enum(['id','cityId','fieldName','key','fieldDescription','fieldType','created_at','updated_at','fieldOptions','fieldDefaultValue','deactivated_at','rowTimestamp']);

export default PermitsExtensionDefinitionsScalarFieldEnumSchema;
